import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import { isEmpty } from "lodash";
import { AccountLayout } from "./accountUi";
import AuthContext from "../../context/AuthContext";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import obj from "../../Utils/helpers";
import { PageShell, FilterCard, ActionButton, TableCard, selectStyle, DateField, thStyle, tdStyle, EntriesHeader, Pager } from "./accountUi";

/* Account Statement — reference kingexch111.com/account-statement. */

const AccountStatementNew = () => {
  const { user } = useContext(AuthContext);
  const [from, setFrom] = useState(moment().subtract(1, "day").format("YYYY-MM-DD"));
  const [to, setTo] = useState(moment().format("YYYY-MM-DD"));
  const [limit, setLimit] = useState(10);
  const [rows, setRows] = useState([]);
  const [dataSource, setDataSource] = useState("");

  const fetchData = async () => {
    const { status, data } = await apiGet(apiPath.accountStatement, {
      fromPeriod: from,
      toPeriod: to,
      page: 1,
      limit,
    });
    if (status === 200 && data?.success) {
      setRows(data?.results?.data || []);
    }
  };

  useEffect(() => {
    if (!isEmpty(user)) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <AccountLayout>
      <PageShell>
        <FilterCard>
          <select value={dataSource} onChange={(e) => setDataSource(e.target.value)} style={selectStyle}>
            <option value="" disabled>Data Source</option>
            <option value="live">LIVE DATA</option>
            <option value="backup">BACKUP DATA</option>
            <option value="old">OLD DATA</option>
          </select>
          <DateField value={from} onChange={setFrom} />
          <DateField value={to} onChange={setTo} />
          <ActionButton onClick={fetchData}>Get Statement</ActionButton>
        </FilterCard>

        <TableCard title="Account Statement">
          <EntriesHeader limit={limit} setLimit={setLimit} />
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "600px" }}>
              <thead>
                <tr>
                  <th style={thStyle}>Date/Time</th>
                  <th style={thStyle}>Deposit</th>
                  <th style={thStyle}>Withdraw</th>
                  <th style={thStyle}>Balance</th>
                  <th style={thStyle}>Remark</th>
                  <th style={thStyle}>From/To</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map((r, i) => {
                    const credit = r?.transactionType === "credit";
                    return (
                      <tr key={i}>
                        <td style={tdStyle}>{obj.dateFormat(r?.createdAt || r?.timeInserted)}</td>
                        <td style={{ ...tdStyle, color: "#1a7a1a" }}>{credit ? r?.amount?.toFixed?.(2) : "-"}</td>
                        <td style={{ ...tdStyle, color: "#c0392b" }}>{!credit ? r?.amount?.toFixed?.(2) : "-"}</td>
                        <td style={tdStyle}>{Array.isArray(r?.newBalance) ? r?.newBalance?.[0]?.toFixed?.(2) : r?.newBalance?.toFixed?.(2)}</td>
                        <td style={{ ...tdStyle, textAlign: "left" }}>{r?.remark}</td>
                        <td style={tdStyle}>
                          {[r?.userData?.userType, r?.userData?.username].filter(Boolean).join(" ") || "-"}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td style={tdStyle} colSpan={6}>
                      No data available in table
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Pager showingText={`Showing ${rows.length === 0 ? 0 : 1} to ${rows.length} of ${rows.length} entries`} />
        </TableCard>
      </PageShell>
    </AccountLayout>
  );
};

export default AccountStatementNew;
